export enum Occupation {
  API = "API",
  EDB = "EDB",
  ICTFM = "ICTFM",
  MED = "MED",
  PLA = "PLA",
}

export const occupationTranslations: Record<Occupation, string> = {
  [Occupation.MED]: "Mediamatiker",
  [Occupation.API]: "Applikationsentwickler",
  [Occupation.PLA]: "Plattformentwickler",
  [Occupation.EDB]: "Entwickler digitales Business",
  [Occupation.ICTFM]: "ICT Fachfrau/-mann",
};

export function getOccupationOptions() {
  return Object.values(Occupation).map((value) => ({
    value,
    label: occupationTranslations[value],
  }));
}
